import ScannedCount from "./ScannedCount";

export default ScannedCount;
